import {
  CasEntitySelect,
  componentProps,
} from 'src/compass/shared/components';

export function CMEScheduleSelect(props: componentProps) {
  return CasEntitySelect('Cme/CommSchedule/Select', props);
}
